export const AdacRoutes = [
  {
    path: '/blackfriday',
    name: 'blackfriday',
    component: () =>
      import(
        /* webpackChunkName: "lp-blackfriday" */ /* webpackPreload: true */ '../views/Landingpages/Adac/BlackFriday.vue'
      ),
    meta: {
      breadcrumb: 'Black Friday',
    },
  },
  {
    path: '/valentinstag',
    name: 'valentine',
    component: () =>
      import(
        /* webpackChunkName: "lp-valentine" */ /* webpackPreload: true */ '../views/Landingpages/Adac/Valentine.vue'
      ),

    meta: {
      breadcrumb: 'Valentinstag',
    },
  },
  {
    path: '/ostern',
    name: 'easter',
    component: () =>
      import(
        /* webpackChunkName: "lp-adac" */ /* webpackPreload: true */ '../views/Landingpages/Adac/Easter.vue'
      ),

    meta: {
      breadcrumb: 'Ostern',
    },
  },
  {
    path: '/muttertag',
    name: 'mothersday',
    component: () =>
      import(
        /* webpackChunkName: "lp-adac" */ /* webpackPreload: true */ '../views/Landingpages/Adac/MothersDay.vue'
      ),

    meta: {
      breadcrumb: 'Muttertag',
    },
  },
  {
    path: '/ssv',
    name: 'ssv',
    component: () =>
      import(
        /* webpackChunkName: "lp-adac" */ /* webpackPreload: true */ '../views/Landingpages/Adac/SummerSale.vue'
      ),

    meta: {
      breadcrumb: 'SSV',
    },
  },
  {
    path: '/motorwelt',
    name: 'motorwelt',
    component: () =>
      import(
        /* webpackChunkName: "lp-adac" */ /* webpackPreload: true */ '../views/Landingpages/Adac/Motorwelt.vue'
      ),

    meta: {
      breadcrumb: 'Motorwelt',
    },
  },
  {
    path: '/weihnachten',
    name: 'christmas',
    component: () =>
      import(
        /* webpackChunkName: "lp-adac" */ /* webpackPreload: true */ '../views/Landingpages/Adac/Christmas.vue'
      ),
    meta: {
      breadcrumb: 'Weihnachten',
    },
  },
]
